import React from 'react';
import PropTypes from 'prop-types';
import 'react-dropdown/style.css';
import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import dashimg from '../../images/screen-shot.png';

class Faq extends React.Component {
  render() {
    return (
      <span>
        <div className="settle-img-box"><img src={dashimg} alt="dashimg" /></div>

      </span>
    );
  }
}

Faq.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });


export default withAlert(connect(mapStateToProps)(Faq));
